import { Component, OnInit, Input, ViewChild } from '@angular/core';
import moment from 'moment';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgForm } from '@angular/forms';

//Services
import { UtilityService } from '../../../core/services/utility.service';
import { PortalSettingsService } from '../../../core/services/portal-settings.service';
import { HiringService } from './../../../pages/hiring/services/hiring.service';
import { ApplicantService } from './../../../pages/hiring/services/applicant.service';

@Component({
  selector: 'app-edit-personal-modal',
  templateUrl: './edit-personal-modal.component.html',
  styleUrls: ['./edit-personal-modal.component.css'],
})
export class EditPersonalModalComponent implements OnInit {
  @ViewChild('applyForm', { static: true }) applyForm: NgForm;
  @Input() isOnboarding: any;
  @Input() info: any;
  portalSettings: any;
  format: string;
  formData: { [key: string]: any } = {};
  sourceDisplay: { [key: string]: any } = {};
  personalInfoRequire: { [key: string]: any } = {};
  datePickerOptions: {
    dateInputFormat: string;
    containerClass: string;
    showTodayButton: boolean;
    showClearButton: boolean;
    clearPosition: string;
    showWeekNumbers: boolean;
  };
  mobileMode: boolean;
  today: any;
  requireReqSourceOnJobReq: boolean;
  personalInfoRequireList: any[] = [];
  stateList: any[] = [];
  maritalStatusList: any[] = [];
  sourceList: any[] = [];
  phoneMask: any;
  oNPerInTaskCustomText: any;

  constructor(
    portalSettingsService: PortalSettingsService,
    private hiringService: HiringService,
    private applicantService: ApplicantService,
    private utilityService: UtilityService,
    public activeModal: NgbActiveModal
  ) {
    this.portalSettings = portalSettingsService.getPortalSettings();
    this.format = utilityService.getDateFormat().toUpperCase();
  }

  ngOnInit(): void {
    this.formData = {};
    this.sourceDisplay = {};
    this.mobileMode = this.utilityService.isMobileMode();
    this.datePickerOptions = {
      dateInputFormat: this.format,
      containerClass: 'theme-blue',
      showTodayButton: true,
      showClearButton: true,
      clearPosition: 'left',
      showWeekNumbers: false,
    };
    this.today = new Date();
    this.requireReqSourceOnJobReq = this.portalSettings.RequireReqSourceOnJobReq.ConfigValue == 1;
    this.personalInfoRequire = {
      FirstName: false,
      LastName: false,
      Email: false,
      Cell: false,
      Phone: false,
      Birthday: false,
      Contact: false,
      Address1: false,
      Address2: false,
      City: false,
      State: false,
      Zip: false,
      Country: false,
      MidName: false,
      Suffix: false,
      MaritalStatus: false,
    };
    this.personalInfoRequireList = this.info.IsOnboarding
      ? this.portalSettings.SetRequireFieldsPersonal.ConfigValue != null
        ? this.portalSettings.SetRequireFieldsPersonal.ConfigValue.split(',')
        : []
      : this.portalSettings.ATSSetRequireFieldsPersonal.ConfigValue != null
        ? this.portalSettings.ATSSetRequireFieldsPersonal.ConfigValue.split(',')
        : [];
    if (this.personalInfoRequireList.length > 0) {
      this.personalInfoRequireList.forEach((val: any) => {
        this.personalInfoRequire[val] = true;
      });
    }
    this.phoneMask = this.portalSettings.PhoneMask.ConfigValue ? this.portalSettings.PhoneMask.ConfigValue.replace(/9/g, '_') : '';
    this.oNPerInTaskCustomText = this.portalSettings.ONPerInTaskCustomText.ConfigValue;
    this.getPersonalInfo();
    this.getVistaOptions();
  }

  getPersonalInfo() {
    this.applicantService.getPersonalInfo().then((response: any) => {
      if (response != null) {
        Object.entries(response).forEach(([key, val]) => {
          if (!this.formData.hasOwnProperty(key)) {
            if (key == 'Birthday')
              this.formData[key] =
                val != null
                  ? new Date(
                      parseInt(moment(val).utc().format('YYYY')),
                      parseInt(moment(val).utc().format('MM')) - 1,
                      parseInt(moment(val).utc().format('DD')),
                      0,
                      0,
                      0,
                      0
                    )
                  : null;
            else this.formData[key] = val;
          }
        });

        if (this.formData.Country == null)
          if (this.portalSettings['CountryDateCode'].ConfigValue == 'US') this.formData.Country = 'US';
          else if (this.portalSettings['CountryDateCode'].ConfigValue == 'AU') this.formData.Country = 'AU';
          else this.formData.Country = 'CA';

        this.getState();
        this.getMaritalStatus();
      }
    });
  }

  getState() {
    this.hiringService.getDependentLookupByColumnName('State', this.formData.Country).then((response: any) => {
      this.stateList = response;
    });
  }

  getMaritalStatus() {
    this.hiringService.getMaritalStatus().then((response: any) => {
      this.maritalStatusList = response;
    });
  }

  countryChange() {
    this.formData.State = null;
    this.formData.Zip = null;
    if (this.formData.Country != 'O') {
      this.formData.CountryOther = null;
      this.getState();
    }
  }

  getVistaOptions() {
    var requestParam = 'reqID=' + this.info.ReqID + '&optionType=contactsource';
    this.hiringService.getVistaOptions(requestParam).then((response: any) => {
      this.sourceList = response;
      if (response != null) {
        response.forEach((val: any, key: any) => {
          this.sourceDisplay[val] = key;
        });
      }
    });
  }

  containAt() {
    var count = 0;
    if (this.formData.Email != null) {
      for (var i = 0; i < this.formData.Email.length; i++) {
        if (this.formData.Email[i] == '@' && i != this.formData.Email.length - 1) count++;
      }
    }
    if (count == 0) return true;
    else return false;
  }

  checkContact(where: string) {
    if (this.formData.Contact == 'C' && this.formData.Cell != null && this.formData.Cell != '' && where == 'C')
      this.formData.Contact = null;
    if (this.formData.Contact == 'P' && this.formData.Phone != null && this.formData.Phone != '' && where == 'P')
      this.formData.Contact = null;
  }

  saveClicked() {
    this.hiringService
      .personalInfoEdit(
        this.info.OnboardID,
        this.formData.FirstName,
        this.formData.LastName,
        this.formData.Email,
        this.formData.Phone,
        this.formData.Address1,
        this.formData.Address2,
        this.formData.City,
        this.formData.State,
        this.formData.Cell,
        this.formData.Zip,
        this.formData.Contact,
        this.formData.ContactSource,
        this.formData.ContactSourceNotes,
        null,
        this.formData.Country,
        this.formData.MidName,
        this.formData.Suffix,
        null,
        this.formData.Birthday != null ? moment(this.formData.Birthday).format('YYYY-MM-DD') : '',
        this.formData.MaritalStatus,
        this.formData.CountryOther,
        false,
        null,
        null
      )
      .then((response: any) => {
        this.activeModal.close();
      });
  }

  cancelClicked = function () {
    this.activeModal.dismiss();
  };

  updatePhoneAndZip(data: string, field: string) {
    switch (field) {
      case 'Cell':
        this.formData.Cell = data;
        break;
      case 'Phone':
        this.formData.Phone = data;
        break;
      case 'Zip':
        this.formData.Zip = data;
        break;
    }
  }
}
